import {
  SanitizeReviewLesson,
  SanitizeReviewRiskLevel,
} from '@/models/sanitizeReview';

const RISK_LEVELS = new Set<SanitizeReviewRiskLevel>([
  'critical',
  'high',
  'medium',
  'low',
  'none',
]);

function hasCurrentRisk(lesson: SanitizeReviewLesson) {
  return (
    ['completed', 'failed'].includes(lesson.status) &&
    ['clean', 'flagged'].includes(lesson.analysisStatus)
  );
}

export function getSanitizeReviewRiskScore(
  lesson: SanitizeReviewLesson
): number | null {
  if (!hasCurrentRisk(lesson)) return null;
  const score = Number(lesson.riskScore);
  if (lesson.riskScore === null || lesson.riskScore === undefined) return null;
  if (!Number.isFinite(score)) return null;
  return Math.round(Math.min(100, Math.max(0, score)));
}

export function getSanitizeReviewRiskLevel(
  lesson: SanitizeReviewLesson
): SanitizeReviewRiskLevel | null {
  if (!hasCurrentRisk(lesson)) return null;
  if (lesson.riskLevel && RISK_LEVELS.has(lesson.riskLevel)) {
    return lesson.riskLevel;
  }

  const score = getSanitizeReviewRiskScore(lesson);
  if (score === null) return null;
  if (score >= 80) return 'critical';
  if (score >= 50) return 'high';
  if (score >= 25) return 'medium';
  if (score > 0) return 'low';
  return 'none';
}

export function sortSanitizeReviewLessonsByRisk(
  lessons: SanitizeReviewLesson[]
) {
  return [...lessons].sort((left, right) => {
    const leftScore = getSanitizeReviewRiskScore(left) ?? -1;
    const rightScore = getSanitizeReviewRiskScore(right) ?? -1;
    return rightScore - leftScore;
  });
}
